import React from 'react'
import PropTypes from 'prop-types'

import './FractionalQuantity.css'

export const FractionalQuantity = ({unitOfMeasure = '', quantity}) => {
  const displayUOM = unitOfMeasure.toLowerCase()

  return (
    <div id='cart-item-fractional-quantity' data-testid='cart-item-fractional-quantity'>
      <span styleName='fractional-quantity'>{quantity} {displayUOM}</span>
    </div>
  )
}

FractionalQuantity.propTypes = {
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unitOfMeasure: PropTypes.oneOf(['LB', 'OZ', 'KG', 'G'])
}
